export function ResolvedComments() {
  // Placeholder
  return null
}
